import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vlyuirulzcjognsfbyrb.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZseXVpcnVsemNqb2duc2ZieXJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAwNTI2MzgsImV4cCI6MjA3NTYyODYzOH0.js6hPEpx1bVvVbxMQdEAHyFzkF5jnLNntkINkh3ia58'

export const supabase = createClient(supabaseUrl, supabaseKey)
